/**
 * @generated SignedSource<<3da7c87d8d877e2a9ec4113e01f97941>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type ZakekeEnvironment = "AI_STUDIO" | "COMPOSER" | "CUSTOMIZER" | "UNKNOWN" | "VIEWER";
export type productIframeQuery$variables = {
  productId: string;
};
export type productIframeQuery$data = {
  readonly model: {
    readonly id: string;
    readonly iframeUrl: {
      readonly aiStudioConfiguratorUrl: string;
      readonly aiStudioCustomizerUrl: string;
      readonly aiStudioViewerUrl: string;
    };
    readonly zakekeEnvironment: ZakekeEnvironment;
  } | null;
};
export type productIframeQuery = {
  response: productIframeQuery$data;
  variables: productIframeQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "productId"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "productId"
      }
    ],
    "concreteType": "Model",
    "kind": "LinkedField",
    "name": "model",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "zakekeEnvironment",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "MarketplaceIframe",
        "kind": "LinkedField",
        "name": "iframeUrl",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "aiStudioCustomizerUrl",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "aiStudioConfiguratorUrl",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "aiStudioViewerUrl",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "productIframeQuery",
    "selections": (v1/*:: as any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "productIframeQuery",
    "selections": (v1/*:: as any*/)
  },
  "params": {
    "cacheID": "b0234f7bbac4ae35cef629f361c151f1",
    "id": null,
    "metadata": {},
    "name": "productIframeQuery",
    "operationKind": "query",
    "text": "query productIframeQuery(\n  $productId: ID!\n) {\n  model(id: $productId) {\n    id\n    zakekeEnvironment\n    iframeUrl {\n      aiStudioCustomizerUrl\n      aiStudioConfiguratorUrl\n      aiStudioViewerUrl\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "e80ccce9e4f55a9a0cef4dd2a1e59dfb";

export default node;
